export default "__VITE_ASSET__D$srlcQF__"